import {useId,View} from "vritra";
import css from "./ProduceMarket.module.css";
import ProduceAisle from "../ProduceAisle/ProduceAisle";


export default function ProduceMarket(props){
    const {parent,id=useId("producemarket")}=props;
    const producemarket=View({parent,id,className:css.producemarket});

    producemarket.innateHTML=`
        <h3 class="${css.name}">produce market</h3>
    `;
    ["fruits","vegetables"].forEach(key=>{
        ProduceAisle({
            parent:producemarket,
            items:props[key],
            name:key+" aisle",
        });
    });

    return producemarket;
}
